var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"vantaRef",staticStyle:{"width":"100%","height":"100vh"}}),_c('div',{staticClass:"my_title"},[_vm._v("Hello,World")])])}
var staticRenderFns = []

export { render, staticRenderFns }